import { render } from "./CompleteCompetition.vue?vue&type=template&id=4cabb455&scoped=true"
import script from "./CompleteCompetition.vue?vue&type=script&lang=js"
export * from "./CompleteCompetition.vue?vue&type=script&lang=js"

import "./CompleteCompetition.vue?vue&type=style&index=0&id=4cabb455&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cabb455"]])

export default __exports__